
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"66","height":"74","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.062 29.094c6.649 0 12.038-6.289 12.038-14.047C39.1 7.29 33.71 1 27.062 1c-6.648 0-12.038 6.29-12.038 14.047 0 7.758 5.39 14.047 12.038 14.047zM20.008 31.564s-1.668 4.13-7.476 4.13c0 0-10.792.83-10.792 16.526M41.592 35.694c-5.808 0-7.476-4.13-7.476-4.13M47.4 73c9.174 0 16.61-7.4 16.61-16.527S56.574 39.947 47.4 39.947c-9.173 0-16.61 7.399-16.61 16.526C30.79 65.601 38.227 73 47.4 73z","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M47.4 49.044v14.868M54.876 56.473H39.934","stroke":"#333","stroke-width":"2","stroke-miterlimit":"10"}})])
          )
        }
      }
    